export default "__VITE_ASSET__CsCSO4HJ__"